import {
  Demographic_Enum,
  Industry_Enum,
  Wui_SellerPackageType_Enum,
} from 'generated/graphql'
import range from 'lodash/range'

export const DOMAIN =
  process.env.DOMAIN || process.env.NEXT_PUBLIC_DOMAIN || 'influexer.com'
export const SHORT_DOMAIN =
  process.env.SHORT_DOMAIN ||
  process.env.NEXT_PUBLIC_SHORT_DOMAIN ||
  'infx.link'
export const MARKETING_DOMAIN = 'influexer.com'
export const PUBLIC_PROFILE_URL = [SHORT_DOMAIN].join('/')

export const GENERIC_ERROR_MESSAGE =
  'Something went wrong. Please try again. If the error persists, please contact support.'

export type PackageSetting = {
  id: Wui_SellerPackageType_Enum
  text: string
  pro: boolean
}

// TODO: Use auto-generated enum
export const PACKAGES_ORDER: PackageSetting[] = [
  {
    id: Wui_SellerPackageType_Enum.Basic,
    text: 'Basic Package',
    pro: false,
  },
  {
    id: Wui_SellerPackageType_Enum.Standard,
    text: 'Standard Package',
    pro: false,
  },
  {
    id: Wui_SellerPackageType_Enum.Monthly,
    text: 'Premium Package',
    pro: true,
  },
  {
    id: Wui_SellerPackageType_Enum.Custom,
    text: 'VIP Package',
    pro: true,
  },
]

export const PACKAGES_OPTIONS = ['Monthly', 'Weekly', 'One Time']

export const SOCIAL_MEDIA_NAMES = [
  'Instagram',
  'Facebook',
  'Twitter',
  'TikTok',
  'Youtube',
  'Twitch',
]

export const AUDICE_SIZE = [
  '0-5k',
  '5k-10k',
  '10k-50k',
  '50k-100k',
  '100k-500k',
  '500k-1m',
  '1m-5m',
  '5m-10m',
  '10m+',
]

export type InfluencerCategory = {
  value: Industry_Enum
  description: string
}

export const INFLUENCER_CATEGORY: InfluencerCategory[] = [
  { value: Industry_Enum.Fashion, description: 'Fashion & Model' },
  { value: Industry_Enum.Beauty, description: 'Beauty' },
  { value: Industry_Enum.Travel, description: 'Travel' },
  { value: Industry_Enum.Lifestyle, description: 'Lifestyle' },
  {
    value: Industry_Enum.Entertainment,
    description: 'Celebrities and Entertainment',
  },
  { value: Industry_Enum.Animals, description: 'Animals (Pets)' },
  { value: Industry_Enum.Art, description: 'Art' },
  { value: Industry_Enum.Gaming, description: 'Gaming' },
  { value: Industry_Enum.Health, description: 'Health & Wellness' },
  { value: Industry_Enum.Fitness, description: 'Sports & Fitness' },
  { value: Industry_Enum.Family, description: 'Family and Parenting' },
  { value: Industry_Enum.Photography, description: 'Photography' },
  { value: Industry_Enum.Business, description: 'Business and Technology' },
  { value: Industry_Enum.Blogger, description: 'Blogger / Vlogger' },
  { value: Industry_Enum.Food, description: 'Food & Cooking' },
  { value: Industry_Enum.Parenting, description: 'Parenting' },
  { value: Industry_Enum.Crafts, description: 'Crafts' },
  { value: Industry_Enum.Memes, description: 'Memes' },
  { value: Industry_Enum.Motivational, description: 'Motivational' },
  { value: Industry_Enum.Other, description: 'Other' },
]

export const COUNTRIES = [
  'World Wide',
  'Asia',
  'Africa',
  'Europe',
  'North America',
  'South America',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia & Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Democratic Republic of Congo',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'eSwatini/Swaziland',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia (previously Macedonia)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of Congo',
  'Republic of Ireland',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'St Kitts and Nevis',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'The Central African Republic',
  'The Gambia',
  'The Netherlands',
  'The Philippines',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'UAE',
  'Uganda',
  'UK',
  'Ukraine',
  'Uruguay',
  'USA',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
]

export const ENGAGEMENT = [
  '0-1%',
  '1-2%',
  '2-5%',
  '5-10%',
  '10-20%',
  '20-30%',
  '30-40%',
  '40-50%',
  '50-60%',
  '60-70%',
  '70-80%',
  '80-90%',
  '90-100%',
]

export const AUDIENCE_GENDER = ['Men', 'Women', 'All']

export const AUDIENCE_AGES = range(13, 121)

export const AVARAGE_LIKES = [
  '1-500',
  '500-1k',
  '1k-5k',
  '5k-10k',
  '10k-50k',
  '50k-100k',
  '100k+',
]

export const DASHBOARD_CATEGORIES = [
  'Today',
  'Yesterday',
  'This Week',
  'This Month',
  'This Year',
]

export const DEMOGRAPHICS: Record<Demographic_Enum, string[] | number[]> = {
  [Demographic_Enum.InfluencerCategory]: [],
  [Demographic_Enum.Location]: COUNTRIES,
  [Demographic_Enum.AudienceSize]: AUDICE_SIZE,
  [Demographic_Enum.AverageEngagement]: ENGAGEMENT,
  [Demographic_Enum.AverageLikesPerPost]: AVARAGE_LIKES,
  [Demographic_Enum.AudienceGender]: AUDIENCE_GENDER,
  [Demographic_Enum.AudienceAges]: AUDIENCE_AGES,
}

export const DEMOGRAPHICS_FRIENDLY: Record<Demographic_Enum, string> = {
  [Demographic_Enum.InfluencerCategory]: 'Target Audience',
  [Demographic_Enum.Location]: 'Audience Location',
  [Demographic_Enum.AudienceSize]: 'Audience Size',
  [Demographic_Enum.AverageEngagement]: 'Average Engagement',
  [Demographic_Enum.AverageLikesPerPost]: 'Average Likes per Post',
  [Demographic_Enum.AudienceGender]: 'Audience Gender',
  [Demographic_Enum.AudienceAges]: 'Audience Ages',
}

export const SERVICE_FEE_PERCENTAGE = 5

export const THEMES = [
  'default',
  'blue',
  'green',
  'pink',
  'gold',
  'red',
  'custom',
]

export const MAX_NUMERIC_LENGHT = '15'

export const LEGAL_PERSON_AGE = 18

export const APP_CRASHED_MESSAGE = `The App just crashed 😔. Please contact support at hello@influexer.com`

export const NO_SPECIAL_CHARACTERS_REGEX = /^[aA-zZ0-9\s]+$/

export const VALID_PERSONAL_NAME_REGEX = /^[A-zÀ-ú0-9\s]+$/

export const VALID_USERNAME_REGEX = /^[a-z0-9_.-]+$/

export const HERO_CAROUSEL = [
  {
    mobile: '/assets/placeholders/inf-dashboard-hero-2-mobile.jpg',
    desktop: '/assets/placeholders/inf-dashboard-hero-2.jpg',
  },
]

export const MIN_AFFILIATE_AMOUNT_TO_WITHDRAW = 50

export const PAGE_LAYOUT_LOCALE_NAMESPACES = [
  'common',
  'footer',
  'socialProviderButton',
  'menu',
]

export const BANNED_DOMAINS = [
  'lucvu.com',
  'javnoi.com',
  'mcatag.com',
  'cgbird.com',
  'neixos.com',
  'huleos.com',
  'vogco.com',
  'doolk.com',
  'ilebi.com',
  'gmail.con',
  'gamil.com',
  'juaxe.com',
  'hormail.com',
  'gufum.com',
  'gmil.com',
  'pucca.com',
  'gmali.com',
  'hotmai.com',
  'gmai.com',
  'hotamil.com',
  'icloup.com',
  'hitmail.com',
  'qiradio.com',
  'hotmsil.com',
  '123gmail.com',
  'cgbird.com',
  'gmal.com',
  'neixos.com',
  'javnoi.com',
  'yaboo.com',
  'gamail.com',
  'icloud.con',
  'huleos.com',
  'fincainc.com',
  'lucvu.com',
  'mcatag.com',
  'hmail.com',
  'gmial.com',
]

export const ICONO_MEMBERSHIPS = [
  // {
  //   id: 'non-membership',
  //   postulation: true,
  //   eyebrown: 'Premios Icono',
  //   title: 'Postulación Sin Memebresia',
  //   price: {
  //     previous: 99,
  //     current: 49,
  //   },
  //   includes: [
  //     'Postulación oficial como creador de contenido o artista a los Premios Icono 2025',
  //     'Flyer de postulado en las redes sociales de Icono',
  //   ],
  // },
  {
    id: 'fans',
    postulation: false,
    eyebrown: 'Premios Icono',
    title: 'Membresia Fans',
    price: {
      previous: 190,
      current: 89,
    },
    includes: [
      '2 Accesos a la Conferencia Icono',
      '2 Accesos a Fiesta y Showcases',
      '2 Accesos a Premios Icono 2025',
    ],
  },
  {
    id: 'influencer',
    postulation: true,
    eyebrown: 'Premios Icono',
    title: 'Membresia Standard',
    price: {
      previous: 299,
      current: 115,
    },
    includes: [
      '2 Accesos a la Conferencia Icono',
      '2 Accesos a Fiesta y Showcases',
      '2 Accesos a Premios Icono 2025',
      [
        'Acceso gratis a la plataforma Influexer PRO (30 dias)',
        'Herramientas para máximizar un comunidad y mentizar',
      ],
      'Postulación oficial como creador de contenido o artista a los Premios Icono 2025',
      'Flyer de postulado en las redes sociales de Icono',
    ],
  },
  {
    id: 'premium',
    postulation: true,
    eyebrown: 'Premios Icono',
    title: 'Membresia Premium',
    price: {
      previous: 549,
      current: 349,
    },
    includes: [
      '2 Accesos a la Conferencia Icono',
      '2 Accesos a Fiesta y Showcases (Zona VIP)',
      '2 Accesos a Premios Icono 2025 (Zona Frontal)',
      '2 Accesos a Alfombra Roja Premios Icono',
      [
        'Acceso gratis a la plataforma Influexer PRO (30 dias)',
        'Herramientas para máximizar un comunidad y mentizar',
      ],
      'Postulacion oficial como creador de contenido o artista a los Premios Icono 2025',
      'Flyer de postulado en las redes sociales de Icono',
      'Entrevista / Artículo exclusivo en el blog de Premios Icono',
    ],
  },
]

export const PUBLIC_ROUTES = [
  '/404',
  '/auth/login',
  '/auth/signup',
  '/auth/verify-request',
  '/auth/invalid-email',
  '/[username]',
  '/user/[username]',

  '/vote/[voteUserCategoryId]',
  '/vote/[voteUserCategoryId]/details',
  '/vote/results',

  '/votaciones/[event]/[voteUserCategoryId]',
  '/votaciones/[event]/[voteUserCategoryId]/detalles',
  '/votaciones/[event]/[voteUserCategoryId]/confirmacion',
  '/votaciones/[event]',

  '/terms-and-conditions',
  '/privacy-policy',
  '/icono/membership',
  '/icono/membership/[id]',
  '/icono/membership/confirmation',

  '/postulations/[event]/[planId]',

  '/events/qr-code',
]
